<template>
 <div style="background-color: #F2F3F7;height: 100vh">
     <div class="my-card">
         <div class="mc-bt">
             <img class="mctext" src="../../assets/mc/hy.svg" mode="widthFix"/>
         </div>
         <div class="mc-txm">
             <img class="mctext1" src="../../assets/mc/txm.svg" mode="widthFix"/>
             <span class="text1">{{member.mbNo}}</span>
         </div>
         <div class="mbinfo">
             <span>{{member.memberName}}<span class="xiao">PULS {{member.pmName==null?'未开通':member.pmName}}</span></span>
             <span class="xiao">红包 0元</span>
         </div>
     </div>
     <div>
         <div class="cards" v-for="item in cards">
             <div class="mbinfo">
                 <div>
                 <span style="font-size: 14px">{{item.cardName}}</span>
                 <span style="margin-left: 6px">{{item.deptName}}</span>
                 </div>
                 <span>{{item.cardNo}}</span>
             </div>
             <div class="card-nr">
                 <div class="cabt">
                     <span class="name">余额</span>
                     <span class="jine">{{item.balance}}元</span>
                 </div>
                 <div class="cabt">
                     <span class="name">赠送金</span>
                     <span class="jine">{{item.give}}元</span>
                 </div>
             </div>
             <div class="card-nr">
                 <div class="cabt">
                     <span class="name">有效期</span>
                     <span class="jine">{{item.dueDate==null?'不限期':item.dueDate}}</span>
                 </div>
             </div>
         </div>
     </div>
 </div>
</template>

<script>
    import {getCookie} from "../../utils/auth";

    export default {
        data() {
            return {
                title: '我的会员卡',
                deptId: '',
                token: '',
                cards: [],
                member: {},
            };
        },
        async created() {
            document.title = "会员中心"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.getMemberCards()
        },
        methods: {
            async getMemberCards() {
                let data = {
                    token: this.token
                }
                let res = await this.$get("/fw/getFwMemberCards", data)
                console.log(res)
                this.member = res.member
                this.cards = res.cards
            },
            onChange(index) {
                this.current = index;
            },
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>

    .my-card {
        width: 100%;
        padding-bottom: 12px;
        background-color: #ffffff;
    }

    .mc-bt {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 45px;
        height: 45px;
        background-color: #D62F36;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        border-bottom-left-radius: 50% 15px;
        border-bottom-right-radius: 50% 15px;
    }

    .mc-txm {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 45px;
    }

    .mctext {
        width: 30%;
        height: 50px;
        box-sizing: border-box;
    }

    .mctext1 {
        margin-top: -15px;
        width: 100%;
        height: 80px;
        box-sizing: border-box;
    }

    .text1 {
        text-align: center;
        display: inline-block;
        width: 80%;
        margin-top: 12px;
        font-size: 20px;
    }

    .mbinfo {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        border-bottom: solid #e5e5e5 1px;
        padding: 8px;
        font-size: 11px;
    }

    .xiao {
        font-size: 11px;
        color: #979895;
        padding: 0 11px;
    }

    .cards {
        padding: 6px 0 27px 0;
        margin: 11px;
        background-color: #ffffff;
    }

    .card-nr {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 11px;
    }

    .cabt {
        width: 50%;
        margin: 27px 11px 0 11px;
    }

    .name {
        display: inline-block;
        width: 55px;
    }

    .jine {
        display: inline-block;
        color: #979895;
    }
    .span1{
        font-size: 17px;
        margin-top: 5px;
    }
</style>
